import React from 'react';
import SVGImage from '../layout/SVGImage';

interface AccountManagementTablePaginationProps {
  testId?: string;
  className?: string;
  length: number;
  currentIndex: number | null;
  setIndex: (idx: number | null) => void;
}

export const AccountManagementTablePagination: React.FC<
  AccountManagementTablePaginationProps
> = ({ testId, className, length, currentIndex, setIndex }) => {
  return (
    <div
      data-testid={testId}
      className={`flex items-center justify-start ${className}`}
    >
      <input
        className="noto-11-normal h-[22px] w-[31px] rounded-[5px] border border-light-6 bg-white p-[5px] text-dark-6 focus:outline-none"
        data-testid={`${testId}-input`}
        value={currentIndex === null ? '' : (currentIndex + 1).toString()}
        onChange={(e) => {
          const value = e.target.value;
          if (value === '') {
            setIndex(null);
            return;
          }
          const nextIdx = parseInt(value, 10) - 1;
          if (isNaN(nextIdx) || nextIdx < 0 || nextIdx > length - 1) {
            return;
          }
          setIndex(nextIdx);
        }}
      ></input>
      <p
        className="noto-11-normal ml-[6px] leading-[11px] text-dark-6"
        data-testid={`${testId}-max`}
      >
        of {length.toString()}
      </p>
      <div className="ml-[7px] flex h-[22px] w-[22px] cursor-pointer items-center justify-center rounded-[2px] bg-light-3">
        <SVGImage
          onClick={() =>
            currentIndex !== null && currentIndex > 0
              ? setIndex(currentIndex - 1)
              : null
          }
          name="pagination-prev-button"
          width={20}
          height={20}
          testId={`${testId}-prev-button`}
        />
      </div>
      <div className="flex h-[22px] w-[22px] cursor-pointer items-center justify-center rounded-[2px] bg-light-3">
        <SVGImage
          onClick={() =>
            currentIndex !== null && currentIndex < length - 1
              ? setIndex(currentIndex + 1)
              : null
          }
          name="pagination-next-button"
          width={20}
          height={20}
          testId={`${testId}-next-button`}
        />
      </div>
    </div>
  );
};
